var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUnmute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11 2a1 1 0 0 1 1-1 7 7 0 0 1 7 7v5a1 1 0 0 1-2 0V8a5 5 0 0 0-5-5 1 1 0 0 1-1-1M6 9a1 1 0 0 1 1 1c0 2.908-.498 4.787-1.197 6H13a1 1 0 1 1 0 2H3a1 1 0 0 1-.041-2h.006a1 1 0 0 0 .141-.041c.136-.053.372-.178.635-.485C4.272 14.854 5 13.38 5 10a1 1 0 0 1 1-1m3.768 11.135a1 1 0 0 1 1.367.363 1 1 0 0 0 1.73 0 1 1 0 1 1 1.73 1.004 3 3 0 0 1-5.19 0 1 1 0 0 1 .363-1.367M4.121 2.293a1 1 0 0 0-1.414 1.414l18.586 18.586a1 1 0 0 0 1.414-1.414z",
  clipRule: "evenodd"
})));
export default SvgIcUnmute;